import React from 'react';
import { notificationType } from './../shared_proptypes';
import StatusIcon from '../StatusIcon';
import NotificationItemDetails from "../NotificationItemDetails";

function TransactionCorrectionUploadNotification({ notification }) {
  return (
    <span className="notification-item" data-test-id="notification_template">
      <StatusIcon status={notification.status} />
      <NotificationItemDetails orgType="Advertiser" orgName={notification.orgName} message={notification.message}/>
    </span>
  );
}

TransactionCorrectionUploadNotification.propTypes = {
  notification: notificationType().isRequired
};

export default TransactionCorrectionUploadNotification;
